module.exports = __webpack_public_path__ + "static/itty-8f35e007609baa614fbf142db9b9bec0.png";